<template>
  <div class="main-header_container">
    <div class="main-header__half--left">
      <h1 class="logo">
        <router-link to="/dashboard">
          <img
            src="/static/images/logo-alvaro-interna.svg"
            alt="Laboratório Alvaro"
          />
        </router-link>
        <p class="product-name">AOL 2.0</p>
      </h1>
    </div>

    <div class="main-header__half--right">
      <CurrentBalance v-if="toggle.prePaid" />
      <div class="icon-header-decoration">
        <div class="whatsapp_container">
          <a
            class="help-link icon-header-decoration"
            target="_blank"
            @click="pushToWhatsapp()"
          >
            <md-icon
              class="whatsapp-icon"
              md-src="/static/images/icon-whatsapp.svg"
            />
          </a>
        </div>
        <infotip
          id="whatsapp"
          icon="/static/images/icon-whats.svg"
          text="Precisa falar com a gente? Utilize o Whatsapp! Clique aqui e envie sua mensagem!"
          :auto-open-on-first-days="true"
        />
      </div>

      <div
        v-if="toggle.notification_view"
        id="messageContainer"
        class="notification_container"
        @click="handleMessageClick"
        @mouseenter="handleUserInteraction"
        @mouseover="handleUserInteraction"
      >
        <div
          id="txtHelp"
          class="icon-header_container"
        >
          <div class="help-link">
            <svg-loader
              id="helpIcon"
              src="/static/images/icon-mail.svg"
              class="mail-icon"
            />
            <div
              v-if="getMessagesNumber > 0 && getMessagesNumber < 100"
              class="button__badge-sup"
            >
              <span class="button__badge-sup__text">{{ getMessagesNumber }}</span>
            </div>
            <div
              v-else-if="getMessagesNumber >= 100"
              class="button__badge-sup__99-plus"
            >
              <span class="button__badge-sup__99-plus__text">+99</span>
            </div>
          </div>
          <md-tooltip
            md-delay="400"
            md-direction="bottom"
          >
            Mensagens
          </md-tooltip>
        </div>
      </div>

      <div
        v-if="toggle.notification_view"
        id="notificationContainer"
        class="notification_container notifications"
        @click="handleNotificationClick"
        @mouseenter="handleNotificationMouseEnter"
        @mouseleave="handleNotificationMouseLeave"
        @mouseover="handleUserInteraction"
      >
        <div
          id="txtHelp"
          class="icon-header_container"
        >
          <div class="help-link">
            <md-icon
              id="helpIcon"
              class="notification-icon"
              md-src="/static/images/icon-mainheader-notification.svg"
            />
            <div
              v-if="getAlertsNumber > 0 && getAlertsNumber < 100"
              class="button__badge-sup"
            >
              <span class="button__badge-sup__text">{{ getAlertsNumber }}</span>
            </div>
            <div
              v-else-if="getAlertsNumber >= 100"
              class="button__badge-sup__99-plus"
            >
              <span class="button__badge-sup__99-plus__text">+99</span>
            </div>
          </div>
          <md-tooltip
            v-if="getAlertsNumber === 0"
            md-delay="400"
            md-direction="bottom"
          >
            Notificações
          </md-tooltip>
        </div>

        <transition name="fade">
          <div
            v-show="getAlertsNumber > 0 && showNotificationTooltip"
            class="notifications__tooltip"
          >
            <span v-if="getAlertsNumber > 1">
              Você tem {{ getAlertsNumber }} notificações não lidas.
            </span>
            <span v-else>Você tem uma notificação não lida.</span>
          </div>
        </transition>
      </div>

      <HelpCenterDropdown v-if="toggle.helpCenterTutorial" />

      <TimeRemainingClock />
    </div>
    <dropdown-menu />
  </div>
</template>

<script>
import UserProfile from './UserProfile'
import Infotip from '@/components/common/infotip/Infotip'
import { mapActions, mapGetters } from 'vuex'
import UserDropdown from './userDropdown/UserDropdown'
import HelpCenterDropdown from '@/components/HelpCenter/HelpCenterDropdown'
import TimeRemainingClock from '@/components/common/timeRemainingClock'
import CurrentBalance from './CurrentBalance.vue'

export default {
  name: 'MainHeader',
  components: {
    'user-profile': UserProfile,
    infotip: Infotip,
    'dropdown-menu': UserDropdown,
    HelpCenterDropdown,
    TimeRemainingClock,
    CurrentBalance,
  },
  data() {
    return {
      showNotificationTooltip: false,
      autoOpenTimer: null,
      autoCloseTimer: null,
      hasUserInteracted: false,
      autoOpenExecuted: false,
    }
  },
  computed: {
    ...mapGetters([
      'isComunicationSidebarVisible',
      'getAlertsNumber',
      'whereIsTabSelected',
      'getMessagesNumber',
      'isPreferenceVisible',
      'profile',
      'toggle',
    ]),
  },
  watch: {
    $route(to, from) {
      if (to.name === 'Dashboard') {
        this.autoOpenExecuted = false
        this.startAutoOpenTimer()
      } else {
        this.clearTimers()
        this.autoOpenExecuted = false
      }
    },
    isComunicationSidebarVisible(newVal) {
      if (newVal && !this.hasUserInteracted && !this.autoOpenExecuted) {
        this.autoOpenExecuted = true
        this.startAutoCloseTimer()
      } else if (!newVal) {
        this.clearAutoCloseTimer()
      }
    },
  },
  mounted() {
    if (this.$route.name === 'Dashboard') {
      this.autoOpenExecuted = false
      this.startAutoOpenTimer()
    }
    this.$root.$on('sidebarInteraction', this.handleUserInteraction)
    this.$root.$on('manualSidebarOpen', this.handleManualSidebarOpen)
  },
  beforeDestroy() {
    this.setComunicationSidebarShowOff(false)
    this.clearTimers()
    this.$root.$off('sidebarInteraction', this.handleUserInteraction)
    this.$root.$off('manualSidebarOpen', this.handleManualSidebarOpen)
  },
  methods: {
    ...mapActions([
      'setComunicationSidebarShowOff',
      'changeTabShowOff',
      'setPreferenceShowOff',
    ]),
    showOffSideBar() {
      this.setComunicationSidebarShowOff(!this.isComunicationSidebarVisible)
    },
    pushEventToAnalytics(action) {
      this.$analytics.pushAnalyticsEvent('ga-event', {
        category: 'Menu superior',
        action: action,
        'id-user': this.profile.id,
        'id-lab': this.profile.id_laboratory,
        'name-lab': this.profile.laboratoryName,
      })
    },
    pushToWhatsapp() {
      window.open('https://api.whatsapp.com/send?1=pt_BR&phone=5545988219193')
      this.pushEventToAnalytics('Link Whatsapp')
    },
    pushToDownload() {
      this.$router.push('/central-de-ajuda')
      this.pushEventToAnalytics('Link Central de Ajuda')
    },
    showOffPreferences() {
      if (this.isComunicationSidebarVisible) {
        this.setComunicationSidebarShowOff(false)
      }
      this.setPreferenceShowOff(!this.isPreferenceVisible)
    },
    openAndCloseSidebar(type) {
      this.onUserInteraction()
      if (type === 'message') {
        if (this.isComunicationSidebarVisible && !this.whereIsTabSelected) {
          this.changeTabShowOff(true)
          this.pushEventToAnalytics('Mensagens')
        } else {
          this.changeTabShowOff(true)
          this.setComunicationSidebarShowOff(!this.isComunicationSidebarVisible)
        }
      } else if (type === 'notification') {
        if (this.isComunicationSidebarVisible && this.whereIsTabSelected) {
          this.changeTabShowOff(false)
          this.pushEventToAnalytics('Notificações')
        } else {
          this.changeTabShowOff(false)
          this.setComunicationSidebarShowOff(!this.isComunicationSidebarVisible)
        }
      }
      if (this.isPreferenceVisible) {
        this.setPreferenceShowOff(!this.isPreferenceVisible)
      }
    },
    startAutoOpenTimer() {
      this.clearTimers()
      this.hasUserInteracted = false

      if (!this.autoOpenExecuted) {
        this.autoOpenTimer = setTimeout(() => {
          if (
            !this.hasUserInteracted &&
            this.$route.name === 'Dashboard' &&
            !this.isComunicationSidebarVisible &&
            !this.autoOpenExecuted
          ) {
            this.changeTabShowOff(false)
            this.setComunicationSidebarShowOff(true)
          }
        }, 5000)
      }
    },
    startAutoCloseTimer() {
      this.clearAutoCloseTimer()

      this.autoCloseTimer = setTimeout(() => {
        if (this.isComunicationSidebarVisible) {
          this.setComunicationSidebarShowOff(false)
        }
      }, 2000)
    },
    clearTimers() {
      this.clearAutoOpenTimer()
      this.clearAutoCloseTimer()
    },
    clearAutoOpenTimer() {
      if (this.autoOpenTimer) {
        clearTimeout(this.autoOpenTimer)
        this.autoOpenTimer = null
      }
    },
    clearAutoCloseTimer() {
      if (this.autoCloseTimer) {
        clearTimeout(this.autoCloseTimer)
        this.autoCloseTimer = null
      }
    },
    onUserInteraction() {
      this.hasUserInteracted = true
      this.clearAutoCloseTimer()
    },
    handleUserInteraction() {
      this.hasUserInteracted = true
      this.autoOpenExecuted = true
      this.onUserInteraction()
    },
    handleNotificationClick() {
      this.handleUserInteraction()
      this.openAndCloseSidebar('notification')
    },
    handleNotificationMouseEnter() {
      this.handleUserInteraction()
      this.showNotificationTooltip = true
    },
    handleNotificationMouseLeave() {
      this.showNotificationTooltip = false
    },
    handleMessageClick() {
      this.handleUserInteraction()
      this.openAndCloseSidebar('message')
    },
    handleManualSidebarOpen() {
      this.hasUserInteracted = true
      this.autoOpenExecuted = true
      this.clearTimers()
    },
  },
}
</script>

<style lang="scss">
@import '../../../static/stylesheets/variables';
@import '../../../static/stylesheets/mixins';

/* COMPONENT: commom/MainHeader.vue */
.main-header_container {
  background-color: #fff;
  height: $mainHeaderHeight;
  padding: 0 30px 0 17px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  position: fixed;
  width: 100%;
  z-index: 104;
  box-shadow: 0 1px 9px 0 rgba(0, 0, 0, 0.1), 0 1px 5px 0 rgba(0, 0, 0, 0.1);

  .main-header__half--left,
  .main-header__half--right {
    flex-grow: 1;
  }

  .main-header__half--left {
    max-width: 225px;
  }

  .logo {
    display: flex;
    align-items: center;

    img {
      border-right: solid 1px #e0e0e0;
      margin-right: 17px;
      padding-right: 11px;
      height: 40px;
      width: 130px;
    }
  }

  .product-name {
    font-weight: 400;
    font-size: 20px;
    line-height: 1.2;
    letter-spacing: -0.3px;
    text-align: left;
    color: #808080;
  }

  .main-header__half--right {
    display: flex;
    flex-direction: row;
    padding-left: 15px;
    align-items: center;
    justify-content: flex-end;
    max-width: calc(100% - 225px);

    @include browser-ie-11 {
      .user-profile {
        width: calc(100% - 360px);
      }
    }

    .user-profile {
      flex-grow: 1;
      display: flex;
      justify-content: flex-end;
      padding-right: 15px;
      // cálculo máximo do tamanho do nome menos o tamanoh dos blocos de download, ajuda e sair
      max-width: calc(100% - 360px);
      min-width: 75px;
    }

    .help-icon,
    .logout-icon {
      color: #840051;
      font-size: 22px;
    }

    .whatsapp-icon {
      width: 30px;
      height: 30px;
      margin: 0 4px !important;
    }

    .notification-icon {
      font-size: 23px;
      min-width: 15px;
      height: 17px;
      min-height: 18px;
      color: #840051;
    }

    .help-link {
      position: relative;
      display: inline-block;
    }

    .preference-bar {
      position: relative;
      display: inline-block;
    }

    .preferences-icon {
      padding-bottom: 3px;
      padding-top: 1px;
    }

    .download_container,
    .help-zendesk,
    .icon-header_container,
    .notification_container {
      color: #840051;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 40px;
      height: 40px;
      margin: auto 4px;

      i.md-icon {
        margin: 0 !important;
        text-align: center;
        display: flex;
        justify-content: center;

        > svg {
          fill: #b2b2b2;
        }
      }
    }
    .whatsapp_container {
      width: 40px;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0 5px;
      cursor: pointer;
    }

    .md-icon {
      margin: 0 0 0 15px;
    }

    .download {
      padding: 0 10px 0 5px;
      border-right: solid 2px #e0e0e0;
    }

    .i-donwloads {
      svg,
      path {
        fill: #b2b2b2;
        max-width: 20px;
      }
    }

    .icon-header {
      padding-left: 5px;
    }

    .logout-button {
      padding-left: 5px;
    }
  }

  .icon-header_container,
  .whatsapp_container {
    &:hover {
      border-radius: 4px;
      background-color: rgba(22, 22, 22, 0.04);
    }
  }

  .notifications {
    position: relative;

    &__tooltip {
      position: absolute;
      top: 62px;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 8px;
      background: #7f1a54;
      border-radius: 4px;
      width: 220px;

      &:after {
        content: '';
        position: absolute;
        border-style: solid;
        border-width: 0 6px 6px 6px;
        border-color: transparent transparent #7f1a54 transparent;
        top: -6px;
        left: 50%;
        transform: translateX(-50%);
      }

      span {
        font-size: 12px;
        color: #fff;
      }
    }
  }
}

.button__badge-sup {
  background-color: #ea0049;
  font-size: 10px;
  position: absolute;
  top: -5px;
  left: 10px;
  width: 1.5em;
  height: 1.5em;
  border-radius: 100%;
  text-align: center;
  vertical-align: middle;
  align-items: center;
  display: inline-flex;
  justify-content: center;

  &__text {
    color: white;
    font-size: 9px;
    font-weight: 900;
  }
}

.button__badge-sup__99-plus {
  background-color: #e11f56;
  border-radius: 2px;
  font-size: 10px;
  position: absolute;
  top: -5px;
  left: 27px;
  width: 1.9em;
  height: 1.8em;
  border-radius: 100%;
  text-align: center;
  vertical-align: middle;
  display: flex;
  display: flex;
  align-items: center;
  display: inline-flex;
  justify-content: center;

  &__text {
    color: white;
    font-size: 9px;
    font-weight: 900;
  }
}

.icon-header-decoration {
  text-decoration: none !important;

  #infotip-whatsapp {
    transform: translate(-46%, 0.3em);
  }
}
</style>
